import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgContractVertical = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		transform: "rotate(-45 12 12)",
		children: /* @__PURE__ */ _jsx("g", {
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("path", { d: "M19 9h-2.58l3.29-3.29a1.004 1.004 0 10-1.42-1.42L15 7.57V5a1 1 0 00-2 0v5a1 1 0 001 1h5a1 1 0 000-2zM10 13H5a1 1 0 000 2h2.57l-3.28 3.29a1 1 0 000 1.42 1 1 0 001.42 0L9 16.42V19a1 1 0 002 0v-5a1 1 0 00-1-1z" })
		})
	})
});
export { SvgContractVertical as ReactComponent };
